export var name = 'orange';
export var breakpoints = {
  small: 480,
  medium: 736,
  large: 960,
  xlarge: 1200,
  xxlarge: 1440
};
export var grid = {
  security: {
    xsmall: 0,
    small: 0,
    medium: '1.5625%',
    large: '3.125%',
    xlarge: '3.125%',
    xxlarge: 45
  },
  gutters: 30,
  maxWidth: 1440
};
export var colors = {
  black: '#000',
  white: '#FFF',
  primary1: '#F16E00',
  primary2: '#FF7900',
  grey1: '#333',
  grey2: '#F4F4F4',
  grey3: '#555',
  grey4: '#CCC',
  functionalSuccess: '#3DE35A',
  functionalError: '#E70002',
  functionalInfo: '#26B2FF',
  functionalAlert: '#FFCD0B',
  functionalDimmedSuccess: '#ECFDEF',
  functionalDimmedError: '#FDE5E6',
  functionalDimmedInfo: '#E9F8FF',
  functionalDimmedAlert: '#FFFAE7',
  text: '#000',
  invertedText: '#FFF',
  transparent: 'transparent'
};
export var text = {
  shared: {
    normal: {
      fontFamily: 'o-HelveticaNeue, Arial, sans-serif',
      fontWeight: 400
    },
    bold: {
      fontFamily: 'o-HelveticaNeue, Arial, sans-serif',
      fontWeight: 700
    }
  },
  lead: {
    xsmall: {
      fontSize: 16,
      lineHeight: 22,
      paddingTop: 7,
      paddingBottom: 10
    },
    small: {
      fontSize: 16,
      lineHeight: 22,
      paddingTop: 7,
      paddingBottom: 10,
      maxWidth: 600
    },
    xlarge: {
      fontSize: 18,
      lineHeight: 24,
      paddingTop: 6,
      paddingBottom: 10,
      maxWidth: 700
    }
  },
  standard: {
    xsmall: {
      fontSize: 14,
      lineHeight: 20,
      paddingTop: 8,
      paddingBottom: 10
    },
    small: {
      fontSize: 14,
      lineHeight: 20,
      paddingTop: 8,
      paddingBottom: 10,
      maxWidth: 600
    },
    xlarge: {
      fontSize: 16,
      lineHeight: 22,
      paddingTop: 7,
      paddingBottom: 10,
      maxWidth: 700
    }
  },
  mention: {
    xsmall: {
      fontSize: 12,
      lineHeight: 18,
      paddingTop: 8,
      paddingBottom: 11
    },
    small: {
      fontSize: 12,
      lineHeight: 18,
      paddingTop: 8,
      paddingBottom: 11,
      maxWidth: 600
    },
    xlarge: {
      fontSize: 14,
      lineHeight: 20,
      paddingTop: 8,
      paddingBottom: 10
    }
  }
};
export var heading = {
  shared: {
    fontFamily: 'o-HelveticaNeue, Arial, sans-serif',
    fontWeight: 700
  },
  h1: {
    xsmall: {
      fontSize: 26,
      lineHeight: 30,
      paddingTop: 4,
      paddingBottom: 10
    },
    medium: {
      fontSize: 34,
      lineHeight: 40,
      maxWidth: 800,
      paddingBottom: 8
    },
    xlarge: {
      fontSize: 42,
      lineHeight: 50,
      maxWidth: 1000,
      paddingBottom: 6
    }
  },
  h2: {
    shared: {
      signature: {
        width: 30,
        height: 6
      }
    },
    xsmall: {
      fontSize: 24,
      lineHeight: 28,
      paddingTop: 5,
      paddingBottom: 10
    },
    medium: {
      fontSize: 30,
      lineHeight: 34,
      maxWidth: 800,
      paddingBottom: 9
    },
    xlarge: {
      fontSize: 34,
      lineHeight: 40,
      maxWidth: 1000,
      paddingBottom: 8
    }
  },
  h3: {
    xsmall: {
      fontSize: 20,
      lineHeight: 24,
      paddingTop: 5,
      paddingBottom: 11
    },
    medium: {
      fontSize: 24,
      lineHeight: 28,
      maxWidth: 800,
      paddingTop: 5,
      paddingBottom: 10
    },
    xlarge: {
      fontSize: 30,
      lineHeight: 34,
      maxWidth: 1000,
      paddingTop: 3,
      paddingBottom: 9
    }
  },
  h4: {
    xsmall: {
      fontSize: 20,
      lineHeight: 24,
      paddingTop: 5,
      paddingBottom: 11
    },
    small: {
      fontSize: 20,
      lineHeight: 24,
      paddingTop: 5,
      paddingBottom: 11,
      maxWidth: 600
    },
    medium: {
      fontSize: 22,
      lineHeight: 26,
      paddingTop: 6,
      paddingBottom: 10
    },
    xlarge: {
      fontSize: 26,
      lineHeight: 30,
      maxWidth: 700,
      paddingTop: 4,
      paddingBottom: 10
    }
  }
};
export var button = {
  shared: {
    maxWidth: 300,
    borderWidth: 1,
    borderRadius: 0,
    paddingTop: 13,
    paddingBottom: 13,
    paddingLeft: 45,
    paddingRight: 45,
    outlineOffset: 4,
    outlineWidth: 2
  },
  full: {
    white: {
      inactive: {
        color: 'white',
        backgroundColor: 'black',
        borderColor: 'black'
      },
      hover: {
        color: 'white',
        backgroundColor: 'grey3',
        borderColor: 'grey3'
      },
      focus: {
        outlineColor: 'primary1'
      },
      active: {
        color: 'white',
        backgroundColor: 'primary1',
        borderColor: 'primary1'
      },
      disabled: {
        color: 'white',
        backgroundColor: 'grey4',
        borderColor: 'grey4'
      }
    },
    black: {
      inactive: {
        color: 'black',
        backgroundColor: 'white',
        borderColor: 'white'
      },
      hover: {
        color: 'black',
        backgroundColor: 'grey4',
        borderColor: 'grey4'
      },
      focus: {
        outlineColor: 'primary2'
      },
      active: {
        color: 'white',
        backgroundColor: 'primary1',
        borderColor: 'primary1'
      },
      disabled: {
        color: 'black',
        backgroundColor: 'grey3',
        borderColor: 'grey3'
      }
    }
  },
  wired: {
    white: {
      inactive: {
        color: 'black',
        backgroundColor: 'transparent',
        borderColor: 'black'
      },
      hover: {
        color: 'grey3',
        backgroundColor: 'transparent',
        borderColor: 'grey3'
      },
      focus: {
        outlineColor: 'primary1'
      },
      active: {
        color: 'primary1',
        backgroundColor: 'transparent',
        borderColor: 'primary1'
      },
      disabled: {
        color: 'grey4',
        backgroundColor: 'transparent',
        borderColor: 'grey4'
      }
    },
    black: {
      inactive: {
        color: 'white',
        backgroundColor: 'transparent',
        borderColor: 'white'
      },
      hover: {
        color: 'grey4',
        backgroundColor: 'transparent',
        borderColor: 'grey4'
      },
      focus: {
        outlineColor: 'primary2'
      },
      active: {
        color: 'primary2',
        backgroundColor: 'transparent',
        borderColor: 'primary2'
      },
      disabled: {
        color: 'grey3',
        backgroundColor: 'transparent',
        borderColor: 'grey3'
      }
    }
  }
};
button.full.grey2 = button.full.white;
button.full.photoLight = button.full.white;
button.full.grey1 = button.full.black;
button.full.photoDark = button.full.black;
button.wired.grey2 = button.wired.white;
button.wired.functionalSuccess = button.wired.white;
button.wired.functionalError = button.wired.white;
button.wired.functionalInfo = button.wired.white;
button.wired.functionalAlert = button.wired.white;
button.wired.functionalDimmedSuccess = button.wired.white;
button.wired.functionalDimmedError = button.wired.white;
button.wired.functionalDimmedInfo = button.wired.white;
button.wired.functionalDimmedAlert = button.wired.white;
button.wired.photoLight = button.wired.white;
button.wired.grey1 = button.wired.black;
button.wired.photoDark = button.wired.black;
export var buttons = {
  spaceBetween: 30
};
export var accordion = {
  standard: {
    container: {
      shared: {
        borderWidth: 1
      },
      folded: {
        borderColor: 'grey4'
      },
      unfolded: {
        borderColor: 'black'
      }
    },
    title: {
      shared: {
        marginRight: 15
      },
      xsmall: {
        paddingTop: 11,
        paddingBottom: 14
      },
      medium: {
        paddingTop: 11,
        paddingBottom: 14
      },
      xlarge: {
        paddingTop: 9,
        paddingBottom: 12
      }
    },
    header: {
      xsmall: {
        minHeight: 69
      },
      medium: {
        minHeight: 69
      },
      xlarge: {
        minHeight: 69
      }
    },
    icon: {
      xsmall: {
        width: 32,
        height: 32,
        marginRight: 15
      },
      medium: {
        width: 32,
        height: 32,
        marginRight: 15
      },
      xlarge: {
        width: 32,
        height: 32,
        marginRight: 15
      }
    },
    arrow: {
      xsmall: {
        width: 12,
        height: 12,
        offsetTop: 0
      },
      medium: {
        width: 12,
        height: 12,
        offsetTop: 0
      },
      xlarge: {
        width: 13.5,
        height: 13.5,
        offsetTop: 1
      }
    },
    content: {
      xsmall: {
        paddingBottom: 30
      },
      medium: {
        paddingBottom: 27
      },
      xlarge: {
        paddingBottom: 27
      }
    }
  },
  large: {
    container: {
      shared: {
        borderWidth: 1
      },
      folded: {
        borderColor: 'grey4'
      },
      unfolded: {
        borderColor: 'black'
      }
    },
    title: {
      shared: {
        marginRight: 15
      },
      xsmall: {
        paddingTop: 8,
        paddingBottom: 12
      },
      medium: {
        paddingTop: 12,
        paddingBottom: 15
      },
      xlarge: {
        paddingTop: 12,
        paddingBottom: 16
      }
    },
    header: {
      xsmall: {
        minHeight: 69
      },
      medium: {
        minHeight: 79
      },
      xlarge: {
        minHeight: 89,
        paddingTop: 29,
        paddingBottom: 29
      }
    },
    icon: {
      xsmall: {
        width: 32,
        height: 32,
        marginRight: 15
      },
      medium: {
        width: 42,
        height: 42,
        marginRight: 20
      },
      xlarge: {
        width: 52,
        height: 52,
        marginRight: 30
      }
    },
    arrow: {
      xsmall: {
        width: 15,
        height: 15,
        offsetTop: 0
      },
      medium: {
        width: 16,
        height: 16,
        offsetTop: 1
      },
      xlarge: {
        width: 19,
        height: 19,
        offsetTop: 1
      }
    },
    content: {
      xsmall: {
        paddingBottom: 30
      },
      medium: {
        paddingBottom: 27
      },
      xlarge: {
        paddingBottom: 27
      }
    }
  }
};
export var alert = {
  container: {
    shared: {
      paddingLeft: 15,
      paddingRight: 15
    }
  },
  titleContainer: {
    hasPadding: {
      paddingTop: 18,
      paddingBottom: 22,
      hasContent: {
        paddingBottom: 13
      },
      hasContentMultiple: {
        paddingBottom: 22
      },
      hasLinkWithoutContent: {
        paddingBottom: 6
      }
    }
  },
  icon: {
    shared: {
      marginRight: 15
    },
    standard: {
      size: 32
    },
    mini: {
      size: 20
    }
  },
  title: {
    shared: {
      maxWidth: 700
    },
    standard: {
      hasPadding: {
        paddingTop: 18,
        paddingBottom: 22
      },
      hasNegativeMargin: {
        marginTop: -2
      }
    },
    mini: {
      paddingTop: 8,
      paddingBottom: 10
    }
  },
  text: {
    shared: {
      maxWidth: 700
    },
    standard: {
      paddingBottom: 22,
      hasLink: {
        paddingBottom: 6
      }
    },
    mini: {
      paddingBottom: 10
    }
  },
  textList: {
    paddingBottom: 30,
    hasLink: {
      paddingBottom: 14
    }
  },
  textListItem: {
    paddingLeft: 24,
    marginBottom: 17,
    bullet: {
      width: 9,
      height: 9,
      offsetTop: 8
    }
  },
  button: {
    bottom: {
      mb: 27 / 15,
      hasContentMultiple: {
        mb: 35 / 15
      }
    },
    right: {
      marginTop: 25,
      marginBottom: 25,
      marginRight: 30,
      marginLeft: 45
    }
  },
  link: {
    standard: {
      mb: 12 / 15
    },
    hasContentMultiple: {
      mb: 20 / 15
    }
  }
};
export var bulletList = {
  item: {
    xsmall: {
      paddingLeft: 27
    },
    xlarge: {
      paddingLeft: 39
    },
    bgWhite: {
      color: 'black'
    },
    bgBlack: {
      color: 'white'
    },
    bgFunctional: {
      color: 'black'
    }
  },
  bullet: {
    xsmall: {
      width: 7,
      height: 7,
      offsetTop: 8,
      offsetLeft: 10
    },
    xlarge: {
      width: 9,
      height: 9,
      offsetTop: 8,
      offsetLeft: 15
    },
    bgWhite: {
      color: 'primary1'
    },
    bgBlack: {
      color: 'primary2'
    },
    bgFunctional: {
      color: 'black'
    }
  }
};
export var link = {
  bgWhite: {
    inactive: {
      color: 'black',
      textDecorationColor: 'black'
    },
    focus: {
      color: 'grey3',
      textDecorationColor: 'grey3'
    },
    active: {
      color: 'primary1',
      textDecorationColor: 'primary1'
    },
    disabled: {
      color: 'grey4',
      textDecorationColor: 'grey4'
    }
  },
  bgFunctional: {
    inactive: {
      color: 'black',
      textDecorationColor: 'black'
    },
    focus: {
      color: 'black',
      textDecorationColor: 'black'
    },
    active: {
      color: 'black',
      textDecorationColor: 'black'
    },
    disabled: {
      color: 'grey4',
      textDecorationColor: 'grey4'
    }
  },
  bgBlack: {
    inactive: {
      color: 'white',
      textDecorationColor: 'white'
    },
    focus: {
      color: 'grey4',
      textDecorationColor: 'grey4'
    },
    active: {
      color: 'primary2',
      textDecorationColor: 'primary2'
    },
    disabled: {
      color: 'grey3',
      textDecorationColor: 'grey3'
    }
  }
};
export var arrowLink = {
  shared: {
    maxWidth: 300,
    next: {
      bgWhite: {
        inactive: {
          color: 'black',
          iconColor: 'primary1',
          textDecoration: 'none'
        },
        focus: {
          color: 'grey3',
          iconColor: 'primary1',
          textDecoration: 'underline',
          textDecorationColor: 'grey3'
        },
        active: {
          color: 'primary1',
          iconColor: 'primary1',
          textDecoration: 'underline',
          textDecorationColor: 'primary1'
        },
        disabled: {
          color: 'grey4',
          iconColor: 'grey4',
          textDecoration: 'none'
        }
      },
      bgFunctional: {
        inactive: {
          color: 'black',
          iconColor: 'black',
          textDecoration: 'none'
        },
        focus: {
          color: 'black',
          iconColor: 'black',
          textDecoration: 'underline',
          textDecorationColor: 'black'
        },
        active: {
          color: 'black',
          iconColor: 'black',
          textDecoration: 'underline',
          textDecorationColor: 'black'
        },
        disabled: {
          color: 'grey4',
          iconColor: 'grey4',
          textDecoration: 'none'
        }
      },
      bgBlack: {
        inactive: {
          color: 'white',
          iconColor: 'primary2',
          textDecoration: 'none'
        },
        focus: {
          color: 'grey4',
          iconColor: 'primary2',
          textDecoration: 'underline',
          textDecorationColor: 'grey4'
        },
        active: {
          color: 'primary2',
          iconColor: 'primary2',
          textDecoration: 'underline',
          textDecorationColor: 'primary2'
        },
        disabled: {
          color: 'grey3',
          iconColor: 'grey3',
          textDecoration: 'none'
        }
      }
    }
  },
  standard: {
    paddingTop: 7,
    paddingBottom: 10,
    icon: {
      size: 12
    }
  },
  mini: {
    paddingTop: 8,
    paddingBottom: 10,
    icon: {
      size: 10
    }
  }
};
arrowLink.shared.previous = arrowLink.shared.next;
arrowLink.shared.up = arrowLink.shared.next;
arrowLink.shared.down = arrowLink.shared.next;
export var input = {
  paddingTop: 35,
  paddingBottom: 13,
  paddingRight: 15,
  outlineOffset: 4,
  outlineWidth: 2,
  outlineColor: 'primary1',
  container: {
    standard: {
      maxWidth: 450
    },
    mini: {
      maxWidth: 260
    }
  },
  label: {
    "default": {
      color: 'grey3'
    },
    hover: {
      color: 'black'
    },
    focus: {
      color: 'black'
    },
    error: {
      color: 'functionalError'
    },
    disabled: {
      color: 'grey4'
    }
  },
  icon: {
    size: 24,
    "default": {
      color: 'primary1'
    },
    error: {
      color: 'functionalError'
    }
  },
  field: {
    "default": {
      backgroundColor: 'white',
      color: 'black',
      borderWidth: 1,
      borderColor: 'grey3'
    },
    hover: {
      borderColor: 'black'
    },
    focus: {
      borderWidth: 2,
      borderColor: 'black'
    },
    error: {
      borderWidth: 2,
      borderColor: 'functionalError'
    },
    disabled: {
      color: 'grey4',
      borderColor: 'grey4'
    }
  },
  helper: {
    paddingTop: 8,
    "default": {
      color: 'grey3'
    },
    disabled: {
      color: 'grey4'
    }
  }
};
export var checkbox = {
  shared: {
    width: 20,
    height: 20,
    borderRadius: 0,
    tickSize: 10,
    outlineOffset: 4,
    outlineWidth: 2
  },
  checked: {
    inactive: {
      borderWidth: 2,
      borderColor: 'primary1',
      backgroundColor: 'transparent',
      tickColor: 'primary1',
      paddingTop: 3,
      paddingBottom: 3,
      paddingLeft: 3,
      paddingRight: 3
    },
    hover: {
      borderWidth: 2,
      borderColor: 'grey3',
      backgroundColor: 'transparent',
      tickColor: 'grey3',
      paddingTop: 3,
      paddingBottom: 3,
      paddingLeft: 3,
      paddingRight: 3
    },
    focus: {
      outlineColor: 'primary1'
    },
    active: {
      borderWidth: 1,
      borderColor: 'grey3',
      backgroundColor: 'transparent',
      tickColor: 'grey3',
      paddingTop: 4,
      paddingBottom: 4,
      paddingLeft: 4,
      paddingRight: 4
    },
    disabled: {
      borderWidth: 2,
      borderColor: 'grey4',
      backgroundColor: 'transparent',
      tickColor: 'grey4',
      paddingTop: 3,
      paddingBottom: 3,
      paddingLeft: 3,
      paddingRight: 3
    }
  },
  unchecked: {
    inactive: {
      borderWidth: 1,
      borderColor: 'black',
      backgroundColor: 'transparent',
      paddingTop: 4,
      paddingBottom: 4,
      paddingLeft: 4,
      paddingRight: 4
    },
    hover: {
      borderWidth: 1,
      borderColor: 'grey3',
      backgroundColor: 'transparent',
      paddingTop: 4,
      paddingBottom: 4,
      paddingLeft: 4,
      paddingRight: 4
    },
    focus: {
      outlineColor: 'primary1'
    },
    active: {
      borderWidth: 2,
      borderColor: 'grey3',
      backgroundColor: 'transparent',
      paddingTop: 3,
      paddingBottom: 3,
      paddingLeft: 3,
      paddingRight: 3
    },
    disabled: {
      borderWidth: 1,
      borderColor: 'grey4',
      backgroundColor: 'transparent',
      paddingTop: 4,
      paddingBottom: 4,
      paddingLeft: 4,
      paddingRight: 4
    }
  }
};
export var checkboxList = {
  shared: {
    container: {
      paddingTop: 6,
      paddingBottom: 10
    },
    checkbox: {
      marginRight: 15
    },
    label: {
      marginTop: 5,
      marginBottom: 5,
      disabledColor: 'grey4'
    },
    subLabel: {
      marginTop: 3,
      disabledColor: 'grey4'
    }
  },
  standard: {
    maxWidth: 450,
    checkbox: {
      offsetTop: 2
    }
  },
  "long": {
    maxWidth: 735,
    checkbox: {
      offsetTop: 14
    }
  }
};
export var itemList = {
  container: {
    maxWidth: 450,
    outlineOffset: 4,
    outlineWidth: 2,
    outlineColor: 'primary1'
  },
  itemContainer: {
    minHeight: 70
  },
  icon: {
    width: 32,
    height: 32,
    marginRight: 15
  },
  label: {
    paddingTop: 11,
    paddingBottom: 14
  },
  subLabel: {
    paddingTop: 3,
    paddingBottom: 13
  },
  arrow: {
    width: 12,
    height: 12,
    marginTop: 1,
    marginRight: -2,
    marginLeft: 17
  }
};
export var stepBar = {
  container: {
    xlarge: {
      paddingBottom: 10 + 22
    },
    medium: {
      paddingBottom: 10 + 20
    },
    small: {
      paddingBottom: 5 + 20
    }
  },
  step: {
    xlarge: {
      width: 44,
      height: 44,
      fontSize: 20,
      lineHeight: 26
    },
    medium: {
      width: 34,
      height: 34,
      fontSize: 16,
      lineHeight: 20
    },
    small: {
      width: 24,
      height: 24,
      fontSize: 14,
      lineHeight: 18
    }
  },
  separator: {
    xlarge: {
      marginLeftRight: 15
    },
    medium: {
      marginLeftRight: 10
    },
    small: {
      marginLeftRight: 5
    }
  },
  labelContainer: {
    xlarge: {
      top: 44 + 10
    },
    medium: {
      top: 34 + 10
    },
    small: {
      top: 24 + 5
    }
  },
  label: {
    xlarge: {
      fontSize: 16,
      lineHeight: 22
    },
    small: {
      fontSize: 14,
      lineHeight: 20
    }
  }
};